import type { Language } from '@inflearn/i18n-tools';
import { i18n } from 'next-i18next';
import { DEFAULT_LANGUAGE } from './constants';

export function getCurrentLanguage(i18nInstance = i18n): Language {
  const lang = i18nInstance ? i18nInstance.language : DEFAULT_LANGUAGE;

  return lang as Language;
}
